import React, { FunctionComponent, ReactNode } from "react";
import Spinner from '@amzn/awsui-components-react-v3/polaris/spinner';
import AuthContextProvider, { useAuthContext } from "./AuthContext";

interface GlobalProvidersProps {
  children: ReactNode
}

export const GlobalProviders = ({ children }: GlobalProvidersProps) => {
  return (
    <AuthContextProvider>
          {children}
    </AuthContextProvider>
  );
};

export const GlobalSpinner: FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  const { userName, userDetailsLoading } = useAuthContext();
  return (
    (!userDetailsLoading && userName) ? <>{children}</> : <><Spinner size="large"></Spinner></>
  )
};